import { HttpErrorResponse } from '@angular/common/http';
import { ApiException } from 'src/core/common/domain/exceptions/api-exception';

/**
 * The request never got an answer from the server, so the operation can be tried again later.
 */
export abstract class ConnectionException extends ApiException {
  protected constructor(message?: string, error?: HttpErrorResponse | Error) {
    super(message, error);
  }
}
